import type { IconDefinition, IconProp } from "@/icons/solid-icons";

/**
 * Section a sidebar entry is grouped under.
 * @enum SidebarSection
 */
export enum SidebarSection {
  Operate = "operate",
  Manage = "manage",
  System = "system",
}

/**
 * Behaviour type for a sidebar entry.
 * @enum SidebarLinkType
 */
export enum SidebarLinkType {
  Link = "link",
  Action = "action",
}

/**
 * Interface representing a single sidebar navigation entry.
 * @interface ISidebarLink
 * @property {string} name: Visible label for the entry.
 * @property {SidebarLinkType} type: Whether the entry navigates (Link) or runs an action (Action).
 * @property {string} [url]: Destination href for Link entries.
 * @property {string} id: Stable identifier used for selection and test ids.
 * @property {boolean} external: Whether the link opens in a new tab.
 * @property {IconProp} [icon]: FontAwesome icon shown beside the label.
 * @property {ISidebarLink[]} [submenu]: Reserved for nested entries (currently unused).
 * @property {Function} [action]: Click handler for Action entries.
 * @property {boolean} isVisible: Whether the entry passes feature-flag gating.
 * @property {SidebarSection} section: Group the entry renders under.
 */
export interface ISidebarLink {
  name: string;
  type: SidebarLinkType;
  url?: string;
  id: string;
  external: boolean;
  icon?: IconProp;
  submenu?: ISidebarLink[];
  action?: () => void;
  isVisible: boolean;
  section: SidebarSection;
}
